package com.zaurh.mapquizwebsite.utils

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import mapquizwebsite.shared.generated.resources.Res
import mapquizwebsite.shared.generated.resources.outfit_bold
import mapquizwebsite.shared.generated.resources.outfit_regular
import org.jetbrains.compose.resources.Font

@Composable
fun getOutfitFont(): FontFamily {
    return FontFamily(
        Font(
            resource = Res.font.outfit_regular,
            weight = FontWeight.Normal
        ),
        Font(
            resource = Res.font.outfit_bold,
            weight = FontWeight.Bold
        )
    )
}

fun Int?.orZero(): Int {
    return this ?: 0
}

fun Double?.orZero(): Double {
    return this ?: 0.0
}

fun Long?.orZero(): Long {
    return this ?: 0L
}

fun Boolean?.orFalse(): Boolean {
    return this ?: false
}

const val EMPTY = ""
const val ZERO = 0
const val ZERO_LONG = 0L